import CustomerDeliveryFileDownload from '@components/file-download/customer-delivery';

const CustomerDeliveryFileDownloadPage = () => {
  return <CustomerDeliveryFileDownload />;
};

export default CustomerDeliveryFileDownloadPage;
